module.exports = __webpack_public_path__ + "9fa4004a221316bd6e7ad6d7063cc732.png";